import { Textarea as MantineTextarea, TextareaProps } from "@mantine/core"
import { forwardRef } from "react"

type Props = TextareaProps

export const TextArea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  return <MantineTextarea {...props} ref={ref} />
})

TextArea.displayName = "TextArea"
